import React from "react";
import styled from "styled-components";

interface ImageBlockProps {
	image: {
		id: string;
		data: {
			id: string;
			title: string;
			file: {
				url: string;
				width: number;
				height: number;
				filesize: number;
			};
		};
		label: string;
	};
	alt: string;
	caption: string;
	width?: "small" | "medium" | "large";
	alignment?: "left" | "right";
}

const sizeMap: Record<string, string> = {
	small: "300px",
	medium: "460px",
	large: "592px",
};

const ImageBlock = ({
	image,
	alt,
	caption,
	width = "medium",
	alignment = "right",
}: ImageBlockProps) => {
	const url = image?.data?.file?.url;
	const title = image?.data?.title || image?.label || "";

	if (!url) return null;

	return (
		<Figure $size={sizeMap[width]} $alignment={alignment}>
			<Img src={url} alt={alt || title} />
			{caption && <Caption>{caption}</Caption>}
		</Figure>
	);
};

const Figure = styled.figure<{ $size: string; $alignment: string }>`
	display: flex;
	flex-direction: column;
	gap: 12px;
	float: ${({ $alignment }) => $alignment};
	width: ${({ $size }) => $size};
	margin: ${({ $alignment }) =>
		$alignment === "right" ? "0 0 24px 48px" : "0 48px 24px 0"};
	margin-bottom: 24px;

	@media (max-width: 950px) {
		float: none;
		width: 100% !important;
		margin: 0 0 24px 0;
	}
`;

const Img = styled.img`
	width: 100%;
	height: auto;
	object-fit: contain;
	border-radius: 16px;
`;

const Caption = styled.figcaption`
	text-align: left;
	width: 100%;
	line-height: 16px;
	font-size: 14px;
	color: #666;
`;

export { ImageBlock };
